<template>
  <div class="menu">
    <div class="menuWrap" :class="{ scrolled: isScrolled }" @mouseenter="handleMouseEnter"  @mouseleave="handleMouseLeave">
      <div class="logo">
        <img v-if="isScrolled" src="../../styles/images/ysy/titlog.png" alt="" />
        <img v-else src="../../styles/images/ysy/titilog2.png" alt="" />
      </div>
      <div class="menuInner">
        <ul>
          <li
            class="menuList"
            :class="activeIndex == 1 ? 'menuListActive' : ''"
            @click="changeMenu(1)"
          >
            首页
          </li>
          <li
            class="menuList"
            :class="activeIndex == 2 ? 'menuListActive' : ''"
            @click="jumpToList('product', pListId)"
          >
            <div class="subMenuTitle">产品体系</div>
            <ul class="subMenuWrap">
              <li
                class="subMenuList"
                v-for="item in pList"
                :key="item.id"
                @click.stop="jumpToList('product', item.id)"
              >
                {{ item.typeName }}
              </li>
            </ul>
          </li>

          <li
            class="menuList"
            :class="activeIndex == 12 ? 'menuListActive' : ''"
            @click="jumpToList('hardware', 35)"
          >
            <div class="subMenuTitle">硬件支撑</div>
            <!-- <ul class="subMenuWrap">
              <li
                class="subMenuList"
               
                @click.stop="jumpToList('hardware', 35)"
              >
                硬件支撑
              </li>
            </ul> -->
          </li>

          <li
            class="menuList"
            :class="activeIndex == 3 ? 'menuListActive' : ''"
            @click="jumpToList('newsCenter', 1)"
          >
            <div class="subMenuTitle">新闻中心</div>
            <ul class="subMenuWrap">
              <li class="subMenuList" @click.stop="jumpToList('newsCenter', 1)">
                公司新闻
              </li>
              <li class="subMenuList" @click.stop="jumpToList('newsCenter', 2)">
                行业动态
              </li>
            </ul>
          </li>
          <li
            class="menuList"
            :class="activeIndex == 4 ? 'menuListActive' : ''"
            @click="jumpToList('industry', bListId)"
          >
            <div class="subMenuTitle">客户案例</div>
            <ul class="subMenuWrap hydt">
              <li
                class="subMenuList"
                v-for="item in bList"
                :key="item.id"
                @click.stop="jumpToList('industry', item.id)"
              >
                {{ item.busName }}
              </li>
            </ul>
          </li>
          <li
            class="menuList"
            :class="activeIndex == 5 ? 'menuListActive' : ''"
            @click="jumpToList('aboutUs', 1)"
          >
            <div class="subMenuTitle">关于我们</div>
            <ul class="subMenuWrap">
              <li class="subMenuList" @click.stop="jumpToList('aboutUs', 1)">
                公司简介
              </li>
              <!-- <li class="subMenuList" @click.stop="jumpToList('aboutUs', 2)">
                企业文化
              </li> -->
              <li class="subMenuList" @click.stop="jumpToList('aboutUs', 3)">
                荣誉资质
              </li>
              <li class="subMenuList" @click.stop="jumpToList('aboutUs', 4)">
                技术支持
              </li>
            </ul>
          </li>
          <li
            class="menuList"
            :class="activeIndex == 6 ? 'menuListActive' : ''"
            @click="jumpToList('recruit', 2)"
          >
            人才招聘
            <!-- <div class="subMenuTitle"></div> -->
            <!-- <ul class="subMenuWrap" >
              <li class="subMenuList" @click="jumpToList('recruit', 1)">
                培训发展
              </li>
              <li class="subMenuList" >人才招聘</li>
            </ul> -->
          </li>
          <li
            class="menuList"
            :class="activeIndex == 7 ? 'menuListActive' : ''"
            @click="jumpToList('contact', 1)"
          >
            联系我们
          </li>
        </ul>
      </div>
    </div>
    <div class="menuBg">
      
      <div class="isHome" v-if="activeIndex == 1">
       <div class="video-container" ref="bannerHeightEle" :style="{ height: bannerHeight + 'px' }">
        <video 
          ref="mainVideo"
          src="https://www.ysyyl.cn/123.m4v"
          class="banner-video"
          controls
          autoplay
          muted
          loop
          playsinline
        ></video>
      </div>
   
        <!-- <el-carousel arrow="never" :interval="3500" :height="bannerHeight+'px'">
          <el-carousel-item>
            <div class="contecnt">
              <img ref="bannerHeightEle" @load="imgLoad" style="width: 100%" src="../../styles/images/ysy/banner2.png" alt="" />
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="contecnt">
              <img src="../../styles/images/ysy/banner1.png" alt="" />
            </div>
          </el-carousel-item>
         
        </el-carousel> -->
      </div>

      <div class="notHome pt60" v-else>
        <img
          v-show="activeIndex == 2 || activeIndex == 12"
          src="../../styles/images/banner2/chanpin_pic.png"
          alt=""
        />
        <img
          v-show="activeIndex == 3"
          src="../../styles/images/banner2/xw.png"
          alt=""
        />
        <img
          v-show="activeIndex == 4"
          src="../../styles/images/banner2/kh.png"
          alt=""
        />
        <img
          v-show="activeIndex == 5"
          src="../../styles/images/banner2/gywm.png"
          alt=""
        />
        <img
          v-show="activeIndex == 6"
          src="../../styles/images/banner2/rc.png"
          alt=""
        />
        <img
          v-show="activeIndex == 7"
          src="../../styles/images/banner2/lxwm.png"
          alt=""
        />
      </div>
      <!-- <div class="menuFont" v-if="activeIndex == 1"></div> -->
    </div>

     <!-- 视频浮窗 -->
      <div class="video-float" v-show="showVideoFloat">
        <!-- src="https://www.ysyyl.cn/123.m4v"  src="https://www.ysyyl.cn/f34a5609a3b9f61b780bb23a32a84f06.mp4" -->
        <video 
          ref="floatVideo"
          src="https://www.ysyyl.cn/f34a5609a3b9f61b780bb23a32a84f06.mp4"
          controls
          autoplay
          muted
          loop
          playsinline
        ></video>
        <!-- <button class="close-float" @click="showVideoFloat = false">×</button> -->
      </div>
  </div>
</template>
<script>
import {
  getSysNews,
  getBusinessList,
  listProductType,
  getCompanyIntro,
  getIndustry,
} from "@/api/manage";
import config from "@/config/url.config";
export default {
  props: ["src"],
  data() {
    return {
      activeIndex: sessionStorage.getItem("index") || "1",
      bList: [],
      pList: [],
      pListId: "",
      bListId: "",
      imgList: [
        "img/homeNew.a902167d.png",
        "img/chanpin_pic.283be25c.png",
        "img/news_pic.f0dce89c.png",
      ],
      bannerHeight: '',
      // isScrolled: false // 添加滚动状态标识
      isScrolled: sessionStorage.getItem("index") != 1,
      showVideoFloat: false, // 视频浮窗显示状态
      videoCurrentTime: 0,  // 记录视频播放进度
    };
  },
  created() {
    this.getBList();
  },
  watch: {
  showVideoFloat: {
    handler(newVal) {
      this.$nextTick(() => {
        if (newVal) {
          // 浮窗显示时，同步进度到浮窗视频，暂停主视频
          if (this.$refs.mainVideo && this.$refs.floatVideo) {
            this.videoCurrentTime = this.$refs.mainVideo.currentTime;
            this.$refs.floatVideo.currentTime = this.videoCurrentTime;
            this.$refs.mainVideo.pause();
            this.$refs.floatVideo.play();
          }
        } else {
          // 浮窗隐藏时，同步进度回主视频，暂停浮窗视频
          if (this.$refs.floatVideo && this.$refs.mainVideo) {
            this.videoCurrentTime = this.$refs.floatVideo.currentTime;
            this.$refs.mainVideo.currentTime = this.videoCurrentTime;
            this.$refs.floatVideo.pause();
            this.$refs.mainVideo.play();
          }
        }
      });
    },
    immediate: false
  },
  activeIndex: {
    handler(newVal) {
      // 当 activeIndex 不等于 1 时，isScrolled 为 true
      if (newVal != 1) {
        this.isScrolled = true;
      } else {
        // 当回到首页时，根据滚动位置决定 isScrolled 的值
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        this.isScrolled = scrollTop > 100;
      }
    },
    immediate: true // 立即执行
  }
},
  mounted () {
    let that = this
    if (this.$refs.bannerHeightEle) {
      this.imgLoad()
      window.addEventListener('resize',() => {
        that.imgLoad();
      },false)
      // 添加滚动监听
      window.addEventListener('scroll', this.handleScroll);
    }

    // 监听主视频播放进度
    this.$nextTick(() => {
      if (this.$refs.mainVideo) {
        this.$refs.mainVideo.addEventListener('timeupdate', this.syncVideoTime);
      }
    });
  },
  methods: {
    // 同步视频播放进度
    syncVideoTime() {
      if (this.$refs.mainVideo && !this.showVideoFloat) {
        this.videoCurrentTime = this.$refs.mainVideo.currentTime;
      }
      if (this.$refs.floatVideo && this.showVideoFloat) {
        this.videoCurrentTime = this.$refs.floatVideo.currentTime;
      }
    },
    // 鼠标移入处理函数
    handleMouseEnter() {
      this.isScrolled = true;
    },
    
    // 鼠标移出处理函数
    handleMouseLeave() {
      // 检查当前是否真的有滚动，如果没有滚动且在首页则恢复原状态
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop <= 100 && this.activeIndex == 1) {
        this.isScrolled = false;
      }
    },
    // 添加滚动处理函数
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      console.log(scrollTop,'scrollTop');
      // 当滚动超过 550 且在首页时，显示浮窗视频
      if (scrollTop > 550 && this.activeIndex == 1) {
        this.showVideoFloat = true;
      } else {
        this.showVideoFloat = false;
      }
      // 当滚动超过一定距离时改变背景色，或者当不在首页时也保持 true
       this.isScrolled = scrollTop > 100 || this.activeIndex != 1;
    },
    
    imgLoad () {
      this.$nextTick(()=>{
        let ref = this.$refs
        this.bannerHeight=ref.bannerHeightEle.height;
      })
    },
    async getBList() {
      let res = await getBusinessList({ pageNo: 1, pageSize: 999 }); //获取行业
      // for(let i=0;i<res.data.length;i++){
      //   console.log(res.data[i].busName.length);
      // }
      let res1 = await getIndustry({ pageNo: 1, pageSize: 999, sortType: "a" });
      res1.data.forEach((item) => {
        res.data.map((item2) => {
          if (item.businessId == item2.id) {
            item.showName = item2.busName;
          }
        });
      });
      this.bList = res.data;
      // var obj={}
      // this.bList=this.bList.reduce((item,next)=>{
      //  obj[next.businessId]?'':obj[next.businessId] = true && item.push(next);
      // return item;
      // },[])
      //将行业应用名称进行冒牌排序，按名称长度从小到大
      // for(let i =0;i<this.bList.length-1;i++){
      //   for(let j=0;j<this.bList.length-i-1;j++){
      //     let k = JSON.parse(JSON.stringify(this.bList[j]))
      //     if(this.bList[j].showName.length>this.bList[j+1].showName.length){
      //       this.bList[j]=JSON.parse(JSON.stringify(this.bList[j+1]))
      //       this.bList[j+1]=k
      //     }
      //   }
      // }
      this.bListId = this.bList[0].id;
      // console.log('this.bList',this.bList);
      let res2 = await listProductType({
        pageNo: 1,
        pageSize: 999,
        sortType: "a",
      }); //获取产品体系
      this.pList = res2.data;
      this.pListId = this.pList[0].id;
      // window.localStorage.setItem('pList',JSON.stringify(this.pList))
    },
    changeMenu(index) {
      // let arr=[2,3,4,5]
      // if(arr.includes(index)){
        // console.log('有');
      // }
      this.activeIndex = index;
      this.isContact = false;
      if (index == 1) {
        this.$router.push("/home");
      }
      sessionStorage.setItem("index", index);
      localStorage.setItem("index", index);
      this.isScrolled = true;
    },
    async jumpToList(name, index) {
    //  console.log("name", name, index);
    
      if (name == "contact") {
        this.changeMenu(7);
      } else if (name == "product") {
        window.scroll(0,0)
        this.changeMenu(2);
      } else if (name == "recruit") {
        this.changeMenu(6);
      } else if (name == "aboutUs") {
        this.changeMenu(5);
      } else if (name == "industry") {
        this.changeMenu(4);
      }  else if (name == "hardware") {
        this.changeMenu(12);
      }
      
      if (name == "newsCenter") {
        this.changeMenu(3);
        let res = await getSysNews({
          type: index,
          pageNo: 1,
          pageSize: 5,
          sortType: "a",
        });
        if (res.data) {
          res.data.forEach((item) => {
            let url = item.sysPicture
              ? config.baseURL +
                item.sysPicture.fileUrl +
                item.sysPicture.newName
              : "";
            item.img = url;
            let aa = decodeURI(item.content);
            var afstr = aa.replace(/<[^>]+>/g, "");
            afstr = afstr.replace(
              /(\s|&mdash;|&nbsp;|&ldquo;|&rdquo;|&hellip;)/g,
              ""
            ); //拿到展示的文本，
            item.showInfo = afstr;
            item.textShow = item.showInfo.substring(0, 69) + "...";
          });
        }
        // let a = this.$route.fullPath.split("/");
        // if (this.$route.name == "newsCenter" && a[2] == index) {
        //   this.$router.go(0);
        // }
        this.$router.push({
          name: name,
          params: { id: index, data: res.data, show: "true", total: res.total },
        });
      } else {
        this.$router.push({ name: name, params: { id: index } });
      }
    },
  },
  beforeDestroy() {
    // 移除滚动监听器，防止内存泄漏
    window.removeEventListener('scroll', this.handleScroll);
    // 移除视频进度监听
    if (this.$refs.mainVideo) {
      this.$refs.mainVideo.removeEventListener('timeupdate', this.syncVideoTime);
    }
  }
};
</script>
<style scoped>
.menu {
  position: relative;
}
.menuWrap {
  /* position: absolute; */
   position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 60px;
  /* background: url(../../styles/images/menuBg.png) no-repeat left top; */
  /* background-size: 100% 100%; */
  /* background-color: #ffffff; */
  /* 默认透明背景 */
  /* background-color: transparent;  */
  display: flex;
  justify-content: space-between;
  /* color: #fff; */
  /* 添加过渡效果 */
  /* transition: background-color 0.3s ease;  */
}

.menuBg {
  width: 100%;
  height: auto;
  position: relative;
}
.menuFont {
  width: 701px;
  height: 78px;
  position: absolute;
  background: url("../../styles/images/newImages/组 90.png");
  left: 549px;
  top: 377px;
  z-index: 9999;
}
.menuBg img {
  width: 100%;
  /* width: 1200px; */
  height: auto;
  overflow: hidden;
}
.isHome /deep/ .el-carousel__container {
  /* height: 500px; */
}
.isHome,
.notHome {
  width: 100%;
  height: 100%;
}
.isHome,
.notHome img {
  width: 100%;
  
  height: 100%;
  overflow: hidden;
}
.contecnt {
  /* background-color: green; */
  width: 100%;
  height: 100%;
}
.logo {
  padding: 12px 0px 0px 260px;
}
.logo img {
  width: 150px;
  height: 40px;
}

/* 导航 */
.menuInner {
  margin-right: 16%;
}
.menuInner > ul {
  height: 100%;
  display: flex;
}
.menuInner > ul > li {
  font-size: 16px;
  margin-right: 16px;
  color: #fff;
  line-height: 60px;
  padding: 0 20px;
  position: relative;
  cursor: pointer;
}
@media screen and (max-width:1600px) {
  .logo{
    padding-left: 120px;
  }
  .menuInner{
    margin-right: 8%;
  }
}

@media screen and (max-width:1300px) {
  .menuInner > ul > li{
    padding:0 15px;
    margin-right: 10px;
  }
  .logo{
    padding-left: 50px;
  }
  .menuInner{
    margin-right: 8%;
  }
}

.menuInner > ul > li:nth-child(1) {
  white-space: nowrap;
}
.menuInner > ul > li:nth-child(n + 1) .subMenuTitle {
  /* width: 4em; */
}
.menuInner li.menuListActive {
  /* background: url(../../styles/images/navBg.png) no-repeat left top;
  background-size: 100% 100%; */
  background: #FFAA00;
  color: #fff;
  /* border-radius: 10px; */
  position: relative;
}
.menuInner > ul > li:hover {
  /* background: url(../../styles/images/navBg.png) no-repeat left top;
  background-size: 100% 100%; */
  background: #FFAA00;
  color: #fff;
}
.subMenuWrap {
  padding: 10px 0px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  display: none;
  top: 100%;
  min-width: 100%;
  /* background: url(../../styles/images/list.png) no-repeat left top;
  background-size: 100% 100%; */
  background: #fff;
  color: #222;
  box-shadow: 0px 4px 18px 0px rgba(137,152,192,0.25);
}
.menuList:hover .subMenuWrap {
  display: block;
}
.menuList .hydt {
  /* height: 240px; */
  /* width: 200px; */
}
.menuList:hover .hydt {
  display: flex !important;
  flex-direction: column !important;
  flex-wrap: wrap !important;
}
.subMenuWrap li,
.subMenuWrapOther li {
  text-align: center;
  line-height: 40px;
  height: 40px;
  font-size: 16px;
  white-space: nowrap;
  box-sizing: border-box;
  padding: 0 10px;
}
.subMenuWrap li:hover,
.subMenuWrapOther li:hover {
  color: #fff;
  /* border-bottom: 1px solid #FFA144; */
  background: #FFAA00;
}
.subMenuWrapOther {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 220px;
}
.pt60 {
  padding-top: 60px;
}



/* 滚动或鼠标悬停时背景变为白色 */
.menuWrap.scrolled,
.menuWrap:hover {
  background-color: #ffffff;
  color: #222;
}

/* 滚动或鼠标悬停时子元素颜色调整 */
.menuWrap.scrolled .menuInner > ul > li,
.menuWrap:hover .menuInner > ul > li {
  color: #222;
}

/* 滚动或鼠标悬停时logo颜色调整（如果需要） */
/* .menuWrap.scrolled .logo img,
.menuWrap:hover .logo img {
  filter: brightness(0);
} */

.video-container {
  /* width: 100%;
  height: 600px;
  overflow: hidden;
  position: relative;  */
   width: 100% !important;
  height: 780px;
  background-color: #000;
  overflow: hidden;
}

.banner-video {
  /* position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; 

  object-fit: fill; */
  width: 100% !important;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* 视频浮窗样式 */
.video-float {
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 320px;
  height: 180px;
  background-color: #000;
  border-radius: 8px;
  overflow: hidden;
  z-index: 9999;
  box-shadow: 0px 4px 18px 0px rgba(137, 152, 192, 0.5);
}

.video-float video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-float .close-float {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 24px;
  height: 24px;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  padding: 0;
}

.video-float .close-float:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
</style>